// Test page to verify all button styles are working
export function ButtonTestPage() {
  return (
    <>
      <div className="pagehead">
        <div className="pagehead__row">
          <div className="pagehead__text">
            <p className="pagehead__eyebrow">Design System</p>
            <h1 className="pagehead__title">Button Test Page</h1>
            <div className="pagehead__facts">
              <span className="fact">Verifying Cyan Room button styles</span>
            </div>
          </div>
        </div>
      </div>

      <div className="pagebody">
        <div className="box">
          <div className="box__head">
            <div className="box__head-text">
              <p className="box__eyebrow">Buttons</p>
              <h2 className="box__title">All Button Variants</h2>
            </div>
          </div>
          <div className="box__body">
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
              <button className="btn btn--primary">Primary Button</button>
              <button className="btn">Default Button</button>
              <button className="btn btn--danger">Danger Button</button>
              <button className="btn btn--ghost">Ghost Button</button>
            </div>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
              <button className="btn btn--primary btn--sm">Primary Small</button>
              <button className="btn btn--sm">Default Small</button>
              <button className="btn btn--danger btn--sm">Danger Small</button>
              <button className="btn btn--ghost btn--sm">Ghost Small</button>
            </div>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <button className="btn btn--primary" disabled>Primary Disabled</button>
              <button className="btn" disabled>Default Disabled</button>
            </div>
          </div>
        </div>

        <div className="box">
          <div className="box__head">
            <div className="box__head-text">
              <p className="box__eyebrow">Forms</p>
              <h2 className="box__title">Form Elements</h2>
            </div>
          </div>
          <div className="box__body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '400px' }}>
              <div className="field">
                <label>Text Input</label>
                <input type="text" placeholder="Enter text..." />
              </div>

              <div className="field">
                <label>Select Dropdown</label>
                <select>
                  <option>Option 1</option>
                  <option>Option 2</option>
                  <option>Option 3</option>
                </select>
              </div>

              <div className="field">
                <label>Textarea</label>
                <textarea placeholder="Enter longer text..." rows={4}></textarea>
              </div>

              <div className="field">
                <label className="cbx">
                  <input type="checkbox" />
                  <span>Checkbox Label</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
